import styled from "styled-components";

export default function DottedListItem({text}) {
  return (
    <Container>
      <Dot />
      <Text>
        {text}
      </Text>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 4px;
`

const Dot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #81A0F6;
  margin-top: 10px;
`

const Text = styled.p`
  font-size: 19px;
  color: #000000;
  margin: 0;
`